import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { INavigationService, IContextService, PershingHttpUtil } from '@pershing/pershing-core';
import { NxiMobileService } from '../services/nxi-mobile.service';

@Component({
    selector: 'trading-mobile-nav',
    templateUrl: 'trading-mobile-nav.component.html'
})
export class TradingMobileNavComponent implements OnInit, OnDestroy {
    parent: any;
    child: any;
    grandChild: any;
    showNav: boolean = false;
    account: any;
    param: any;
    queryParam: any = {};
    isExtendedHours: boolean = false;
    constructor(
        private navigationService: INavigationService,
        private contextService: IContextService,
        private mobileService: NxiMobileService) {
            this.navigationService.getParentPage().subscribe(
                parent => {
                    this.parent = parent;
            });
            this.navigationService.getChildPage().subscribe(
                child => {
                    this.child = child;
            });
            this.navigationService.getGrandChildPage().subscribe(
                grandChild => {
                    console.log('check for grand child ----' + grandChild);
                    this.grandChild = grandChild;
            });
            this.mobileService.checkExtendedHour().subscribe(
                resp => {
                    this.isExtendedHours = (resp && resp.isExtendedHour);
                }
            );
    }
    ngOnInit(): void {
        console.log(' In trading mobile nav OnInit');
        let urlSearchParam = new URLSearchParams(window.location.search);
        let urlParam = {};
        urlSearchParam.forEach(function(value, key) {urlParam[key] = value; });
        this.queryParam = urlParam;
        if (this.contextService.getRouteContext()) {
            this.queryParam = PershingHttpUtil.getJsonObjectFromQueryString(this.contextService.getRouteContext());
        }
        if (window['require']) {
            let topic = window['require']('dojo/topic');
            topic.subscribe('/nxi/trading/account', (accountObj) => {
                if (accountObj) {
                this.account = accountObj.acctReference;
                }
            });
        }
    }

    public ngOnDestroy() {
        console.log(' In thirdlevelComponent Destroy ');
    }

    handleThirdLevelNavigation(grandchildpage): void {
        this.showNav = false;
        let url = '/nxi/transact/neworder/' + grandchildpage.id;
        if (grandchildpage.id === 'stocktrading') {
            this.param = {'account' : this.account , 'tradeType' : 'EQUITY'};
        } else if (grandchildpage.id === 'mutualfundtrading') {
            this.param = {'account' : this.account , 'tradeType' : 'MUTUAL_FUND'};
        } else if (grandchildpage.id === 'optiontrading') {
            this.param = {'account' : this.account , 'tradeType' : 'OPTION'};
        } else if (grandchildpage.id === 'trading529') {
            this.param = {'account' : this.account , 'tradeType' : 'PLAN_529FUND'};
        } else if (grandchildpage.id === 'extendedhours') {
            this.param = {'account' : this.account , 'tradeType' : 'EQUITY', 'isExtended': 'Y'};
        }
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
            'gotoPage': url,
            'gotoParams': this.param
            }
            }));
    }

    handleRedirection(): void {
        let url = '/nxi/transact/neworder/';
        let tradeType = this.queryParam.tradeType;
        if (this.queryParam) {
            if (tradeType === 'EQUITY') {
                url += (this.queryParam.isExtended === 'Y' && this.isExtendedHours) ? 'extendedhours' : 'stocktrading';
            } else if (tradeType === 'MUTUAL_FUND') {
                url += 'mutualfundtrading';
            } else if (tradeType === 'OPTION') {
                url += 'optiontrading';
            } else if (tradeType === 'PLAN_529FUND') {
                url += 'trading529';
            } else {
                url = null;
                this.showNav = (!this.grandChild);
            }
        }
        if (url) {
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                'gotoPage': url,
                'gotoParams': this.queryParam
                }
            }));
        }
    }

    handleBackNavigation(): void {
        let url = '/nxi/transact/neworder';
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
            'gotoPage': url
            }
            }));
    }
    @HostListener('document:showTradingNav', ['$event'])
    showTradingNav(event: any) {
        console.log(' In showTradingNav event' + this.grandChild);
        if (this.queryParam && this.queryParam.account && this.queryParam.tradeType && !this.grandChild) {
            this.handleRedirection();
        } else if (!this.grandChild) {
            this.showNav = true;
        }
        console.log('out---------------' + this.showNav);
    }
}
